module.exports = __webpack_public_path__ + "img/img_loading.f1723b3e.svg";